import addons from './addons';
import airQuality from './airQuality';
import alerts from './alerts';
import astral from './astral';
import auth from './auth';
import calendar from './calendar';
import common from './common';
import forecastMaps from './forecastMaps';
import intro from './intro';
import landing from './landing';
import network from './network';
import providerHints from './providerHints';
import providerIntro from './providerIntro';
import reports from './reports';
import sensors from './sensors';
import settings from './settings';
import units from './units';
export default {
    addons,
    airQuality,
    alerts,
    astral,
    auth,
    calendar,
    common,
    forecastMaps,
    landing,
    network,
    providerHints,
    providerIntro,
    reports,
    sensors,
    settings,
    units,
    intro,
};
